/** 사유서 세부분류 (신청 UI에서만 필수) */
export const EXCUSE_REASON_CATEGORIES = [
	"경건회 불참",
	"지각",
	"단말기 오류",
	"결근",
	"대체휴무",
	"기타",
];
